import FavoriteSuggestionType from './types/FavoriteSuggestionType';

export default {
    showFavoriteSuggestions: {
        datapoint: {
            name: 'TnS_ShowFavoriteSuggestions',
            customData: (
                searchInputLength: number,
                peopleSuggestionCount: number,
                folderSuggestionCount: number,
                searchSuggestionCount: number,
                categorySuggestionCount: number,
                groupSuggestionCount: number
            ) => [
                searchInputLength,
                peopleSuggestionCount,
                folderSuggestionCount,
                searchSuggestionCount,
                categorySuggestionCount,
                groupSuggestionCount,
            ],
        },
    },
    addFavoriteFromPicker: {
        datapoint: {
            name: 'TnS_AddFavoriteFromPicker',
            customData: (
                searchInputLength: number,
                favoriteSuggestionType: FavoriteSuggestionType
            ) => [searchInputLength, favoriteSuggestionType],
        },
    },
};
